<wdpr-modal #loadingModal class="loading-modal" disable-close-on-background hide-close-icon>
  <div class="modal-body-wrapper" slot="body">
    <div class="modal-body modal-center">
      <img class="icon" aria-live="assertive" src="assets/images/loader-dark.gif" aria-label="Loading..." alt="Loading...">
      <h2 class="h2-text">{{ 'Common.WaitWhileMessage' | translate }}</h2>
      <h2 class="h2-text">{{ 'ConfirmationMessage.ConfirmationLoadingMessage2'| translate }}</h2>
    </div>
  </div>
</wdpr-modal>
